import { keyframes } from '@emotion/react';
import { Box, Overlay } from '@inflearn/ds-react-next';
import { random, range } from 'lodash-es';

const COLORS = [
  '#057f75',
  '#a52626',
  '#000080',
  '#ff8f8f',
  '#0060ff',
  '#044640',
  '#a1dcc8',
  '#eb5757',
  '#b8dcff',
];

export function Confetti({ count, colors = COLORS }: { count: number; colors?: string[] }) {
  return (
    <Overlay
      styles={{
        root: { background: 'unset', pointerEvents: 'none' },
      }}
    >
      {range(count).map((i) => {
        const delay = random(0, 10, false);

        return (
          <Box
            key={i}
            css={{
              top: '-16px',
              position: 'fixed',
              animationName: fall,
              animationTimingFunction: 'linear',
              animationIterationCount: 'infinite',
              animationPlayState: 'running',
              left: `${random(0, 100, false)}%`,
              animationDelay: `${delay}s`,
              animationDuration: `${random(2, 5, false)}s`,
            }}
          >
            <Box
              css={{
                width: '4px',
                height: '8px',
                animationName: shake,
                animationTimingFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
                animationIterationCount: 'infinite',
                animationPlayState: 'running',
                willChange: 'transform',
                background: colors[i % colors.length],
                animationDelay: `${delay}s`,
                animationDuration: `${random(1, 4, false)}s`,
              }}
            ></Box>
          </Box>
        );
      })}
    </Overlay>
  );
}

const fall = keyframes`
    0% {
        transform: translateY(0px);
    }
    100% {
        transform: translateY(calc(100vh + 16px));
    }`;

const shake = keyframes`
    0% {
        transform: translateX(0px) rotate(-30deg);
    }
    50% {
        transform: translateX(80px) rotate(30deg);
    }
    100% {
        transform: translateX(0px) rotate(-30deg);
    }
`;
